// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"531":"testimonials","883":"shop","964":"product"}[chunkId] + "." + {"531":"2614c7dc","883":"460cf5eb","964":"f1848191"}[chunkId] + ".css";
};